import angular from 'angular';

import SideMenuHeaderComponent from './side-menu-header-component';


export default angular
  .module('side-menu-header', [])
  .component('sideMenuHeader', new SideMenuHeaderComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/side-menu/components/side-menu-header/side-menu-header-module.js